export const AUTH_FIELD_LIMITS = {
    loginMinLength: 3,
    loginMaxLength: 64,
    passwordMinLength: 8,
    passwordMaxLength: 128,
};

const shouldShowHint = (value, touched) => touched || value.length > 0;

export const getLoginFieldHint = (login, touched) => {
    const value = login.trim();
    if (!shouldShowHint(login, touched)) {
        return '';
    }
    if (value.length < AUTH_FIELD_LIMITS.loginMinLength) {
        return 'Минимум 3 символа';
    }
    if (value.length > AUTH_FIELD_LIMITS.loginMaxLength) {
        return 'Максимум 64 символа';
    }
    return '';
};

export const getPasswordFieldHint = (password, touched) => {
    if (password.length > AUTH_FIELD_LIMITS.passwordMaxLength) {
        return 'Максимум 128 символов';
    }
    if (shouldShowHint(password, touched) && password.length < AUTH_FIELD_LIMITS.passwordMinLength) {
        return 'Минимум 8 символов';
    }
    return '';
};

export const getPasswordFieldHelperText = (password) => {
    if (password.length > AUTH_FIELD_LIMITS.passwordMaxLength) {
        return { text: 'Максимум 128 символов', isError: true };
    }
    if (password.length > 0 && password.length < AUTH_FIELD_LIMITS.passwordMinLength) {
        return { text: 'Минимум 8 символов', isError: true };
    }
    if (password.length < AUTH_FIELD_LIMITS.passwordMinLength) {
        return { text: 'Минимум 8 символов', isError: false };
    }
    return { text: '', isError: false };
};

export const getPasswordConfirmHint = (password, passwordConfirm, touched) => {
    if (!shouldShowHint(passwordConfirm, touched)) {
        return '';
    }
    if (passwordConfirm !== password) {
        return 'Пароли не совпадают';
    }
    return '';
};
